goog.provide('el8.apphome.reqAct.patientLetters');

goog.require('el8.apphome.reqAct.QueueTab');
goog.require('el8.template.render.reqAct');
goog.require('el8.service.urls');


el8.apphome.reqAct.patientLetters = (function() {

    var name = 'patientLetters';
    var urlName = 'patient-letters';
    var title = 'Patient Letters';

    return new el8.apphome.reqAct.QueueTab({
        name: name,
        urlName: urlName,
        title: title,
        emptyMsg: 'No patient letters requiring action',
        addlFeedRenderFn: function(queueType) {
            /* If we have a physician user ID, fetch by physician user ID */
            queueType = queueType || el8.data.currUser.getId();
            if (!isNaN(queueType)) {
                var user = el8.data.practiceUsers.getById(queueType*1);
                if (user.isPhysician()) {
                    $.el8_ajax({
                        url: el8.service.urls.get('outstandingPassportInvites', [user.getId()]),
                        type: 'GET',
                        success: function(data) {
                            $('#outstanding-passport-count').text(data);
                        }
                    });
                    $('#outstanding-passport-link').attr('href', '/population/?initialtab=patientlist&puid='+user.getStaffId()+'&passport=invited&load=1');
                    return;
                }
            }
            /* Else, fetch whole practice queue */
            $.el8_ajax({
                url: el8.service.urls.get('outstandingPassportInvites'),
                type: 'GET',
                success: function(data) {
                    $('#outstanding-passport-count').text(data);
                }
            });
            $('#outstanding-passport-link').attr('href', '/population/?initialtab=patientlist&puid=all&passport=invited&load=1');
        }
    });

})();
